import React from "react";
import { Box } from "@mui/material";

const SelectMediaType = ({ mediaType, onChange }) => {
  return (
    <Box mb={2}>
      {/* Label for Select */}
      <label
        htmlFor="media-type-select"
        style={{
          display: "block",
          marginBottom: "8px",
          fontFamily: "basic-sans",
          fontWeight: "700",
          color: "white", 
        }}
      >
        Media Type
      </label>

      {/* Select Dropdown */}
      <select
        id="media-type-select"
        value={mediaType}
        onChange={onChange}
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "4px",
          border: "1px solid #ccc", // Adjust for your theme
          backgroundColor: "#f9f9f9", // Adjust for your theme
          fontFamily: "basic-sans, sans-serif",
          color: "#000", // Adjust for your theme
          outline: "none",
          boxSizing: "border-box",
        }}
      >
        <option value="image">Image</option>
        <option value="video">Video</option>
      </select>
    </Box>
  );
};

export default SelectMediaType;
